import { render, staticRenderFns } from "./AdminChannelGroupingsComponent.vue?vue&type=template&id=4c119734"
import script from "./AdminChannelGroupingsComponent.vue?vue&type=script&lang=js"
export * from "./AdminChannelGroupingsComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminChannelGroupingsComponent.vue?vue&type=style&index=0&id=4c119734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports